var React = require('react');

function VerticalLine (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.90607 1.00861C41.7049 4.53003 87.9998 1.00861 145.5 59.5001C196.146 111.019 185.659 183.003 172.5 225.5C22.6271 251.27 -9.15259 315.017 4.90453 396.5C18.9617 477.983 112.187 424.092 178.5 502.499C219.383 550.838 188.488 628.514 172.5 644.499","stroke":"#ECFB70","strokeWidth":"2","strokeDasharray":"10 10"}));
}

VerticalLine.defaultProps = {"width":"200","height":"646","viewBox":"0 0 200 646","fill":"none"};

module.exports = VerticalLine;

VerticalLine.default = VerticalLine;
